(function () {

    'use strict';

    angular.module('iplusjs.druck.downloadLink', [
        'lodash',
        'ngSanitize',
        'mm.foundation.mediaQueries',
        'mm.foundation.position',
        'mm.foundation.transition',
        'mm.foundation.modal',
        'iplusjs.utils.misc'
    ])
        .component('iplusjsDruckDownloadLink', {
            bindings: {
                file: '<iddlFile',
                url: '<iddlUrl',
                action: '&iddlAction',
                text: '@iddlText',
                trackingTarget: '@iddlTrackingTarget',
                title: '@iddlTitle',
                cssClass: '@iddlCssClass'
            },
            templateUrl: 'common/druck/druckDownloadLink.html',
            controller: DruckDownloadLinkController,
            controllerAs: 'druckDownloadVm'
        });

    DruckDownloadLinkController.$inject = [
        '$window',
        '$q',
        '$modal',
        '$element',
        'lodash',
        'MiscUtilsService'
    ];

    function DruckDownloadLinkController($window, $q, $modal, $element, _, MiscUtilsService) {
        var vm = this;

        vm.$onInit = onInit;
        vm.saveOrOpenBlob = saveOrOpenBlob;
        vm.showPdf = showPdf;

        function activate() {
            vm.isMsSaveOrOpenBlob = !!$window.navigator.msSaveOrOpenBlob;
            vm.cssClassDruck = vm.cssClass || 'link secondary download';
            vm.trackingTarget = vm.trackingTarget || vm.text || vm.title;
            vm.linkText = vm.text;
            vm.pdfjsViewerEnabled = MiscUtilsService.isPdfjsViewerEnabled();
            vm.isAppModus = MiscUtilsService.isAppModus();
        }

        function onInit() {
            activate();
        }
        function saveOrOpenBlob() {
            if (!vm.isMsSaveOrOpenBlob || !vm.file) {
                return;
            }

            $window.navigator.msSaveOrOpenBlob(vm.file.blob, vm.file.name);
        }

        function showPdf() {
            var deferred = $q.defer(),
                pdfLoadedDeferred = $q.defer(),
                modalPdfViewer,
                focusElementAfterCloseModal = $element[0].querySelector('.btn-pdf');

            modalPdfViewer = $modal.open({
                templateUrl: 'modal/modalPdfViewer.html',
                windowClass: 'xlarge pdfjs',
                controller: 'ModalPdfViewerController',
                controllerAs: 'modalVm',
                resolve: { /* @ngInject */
                    pdf: [function () {
                        return deferred.promise;
                    }]
                }
            });

            modalPdfViewer.result.then(function () {
                focusElementAfterCloseModal && focusElementAfterCloseModal.focus();
            }).catch(function (error) {
                focusElementAfterCloseModal && focusElementAfterCloseModal.focus();
            });

            deferred.resolve(pdfLoadedDeferred);
            pdfLoadedDeferred.resolve({
                url: _.get(vm.file, 'url') || vm.url,
                name: vm.text
            });
        }
    }
})();
